module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAC9SURBVGhD7Y8xCgIxFAUXsRRBsLb2EB7MQ3gSa0/igRLnY5osrGn+yhYz8KqXz8tMIiKyeWqtO3IapZRybCcddPv524Uc2sk6MHAhQxB5t5MOqtv3xW+4f7WTdWBDkYBKkVTYUCSgUiQVNhQJqBRJhQ1FAipFUmFDkYBKkVTYUCSgUiQVNhQJqBRJhQ1FAipFUmFDkYBKkVTYUCSgUiQVNhQJqDYjcibPUfjIo5100F3nbxdybyciIiJ/YJo+yQCY6G/LWmUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/components/_molecules/MediaLibraryFull/components/MediaPreviewModal/assets/pause-icon.png
// module id = 1471
// module chunks = 0